import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">


                                            <div className="circle_title" style={{paddingTop: '0px'}}><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>THE DELIVERY PROCESS
                                            </div>
                                            <p>We’ll bet you sometimes feel your efforts to achieve things in
                                                the time given are taken for granted,
                                                because you only hear about it when you don’t! And that’s
                                                exactly our point. While those you work
                                                with are undoubtedly appreciative of your efforts, failure to
                                                deliver reliably (however infrequently),
                                                inevitably raises issues of trust, especially if it impacts
                                                their own work.</p>
                                            <p>However, as is so often the case, once you have a method, it’s
                                                easy. Our model outlines the
                                                processes necessary to ensure effective, timely delivery:
                                            </p>
                                            <div className="innovativeimg">

                                                <img
                                                    src={require('@images/delivery-img.png')}
                                                    alt=""/>

                                            </div>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>CLARIFYING WHAT NEEDS TO BE DELIVERED
                                            </div>
                                            <div className="uiheading"><p>The way to make sure you always
                                                deliver is to ask yourself (and whoever else may be involved)
                                                the following questions – don’t be tempted to steam ahead before
                                                doing this...</p></div>
                                            <ul className="greenbullet-list">
                                                <li>
                                                    <div className="uiheading"><p><span className="subtiltereg">Should I be doing this?</span>
                                                    </p><p>Never begin a task without checking the
                                                        appropriateness of your involvement – and do
                                                        it in a way that makes it clear you’re not trying to
                                                        avoid responsibility! Explain that
                                                        effective delivery is dependent upon giving the task to
                                                        whoever is most able or likely
                                                        to fulfil it successfully. </p></div>
                                                </li>
                                                <li>
                                                    <div className="uiheading"><p><span className="subtiltereg">What exactly do I need to do?</span>
                                                    </p><p>Effective delivery is about more than ‘getting things
                                                        done’, it’s about producing what
                                                        is needed. Clarify your understanding of the task in as
                                                        much detail as you can.
                                                        Contact the key stakeholder (by email ideally, so you
                                                        have a written record) and ask
                                                        for confirmation that you correctly understand
                                                        requirements and expectations.</p></div>
                                                </li>
                                                <li>
                                                    <div className="uiheading"><p><span className="subtiltereg">When exactly do I need to complete it?</span>
                                                    </p><p>You might complete the task successfully, but if it’s
                                                        a day after the deadline it’ll still be less
                                                        effective, less useful or even redundant. Make sure you
                                                        clarify when the work is needed.</p></div>
                                                </li>
                                                <li>
                                                    <div className="uiheading"><p><span className="subtiltereg">Is there anything else I need to know?</span>
                                                    </p><p>Sometimes, you may only discover something which
                                                        would have been useful to know
                                                        while you were working on the task, after its
                                                        completion. This could be unknown
                                                        requirements or end uses which you need to factor into
                                                        your planning.</p></div>
                                                </li>
                                            </ul>
                                            <p>Now, you should have a much clearer idea of the ‘what’ ‘why’ and
                                                ‘when’, which makes it easier
                                                to work out ‘how’.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}